export default __webpack_public_path__ + "static/media/twenty.df94d0ad.jpg";